import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { SuperAdminLayout } from './layout/SuperAdminLayout'
import { SystemSection } from './sections/SystemSection'
import { TenantsSection } from './sections/TenantsSection'
import { TenantDetailSection } from './sections/TenantDetailSection'
import { UsersSection } from './sections/UsersSection'

export default function SuperAdmin() {
    return (
        <SuperAdminLayout>
            <Switch>
                <Route exact path="/superadmin">
                    <Redirect to="/superadmin/system" />
                </Route>
                <Route exact path="/superadmin/system">
                    <SystemSection />
                </Route>
                <Route exact path="/superadmin/tenants">
                    <TenantsSection />
                </Route>
                <Route path="/superadmin/tenants/:tenantId">
                    <TenantDetailSection />
                </Route>
                <Route exact path="/superadmin/users">
                    <UsersSection />
                </Route>
                <Redirect to="/superadmin/system" />
            </Switch>
        </SuperAdminLayout>
    )
}
